import React from "react";
import Menu from "@shared/layout/Menu";
import Materials from "@features/materials/components/Materials";

const routes = [
  {
    path: "/materials",
    element: <Menu content={<Materials />} />,
    isProtected: true,
  },
];

export default routes;
